<template>
<base-modal title="Edit Image">
  <form>
    <div class="columns">
      <div class="column">
        <text-input 
          :disabled="loading"
          :value="image.caption"
          @input="setCaption"
          :error="errors.caption">
          Caption
        </text-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button 
          :disabled="loading"
          :working="working" 
          @submit="save" 
          class="is-success is-rounded">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</base-modal>  
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {

  props: {
    imageId: Number,
  },

  data:() => ({
    working: false,
    loading: true
  }),

  created() {
    this.loadGalleryImage()
  },

  destroyed() {
    this.$store.commit('gallery/resetGalleryImage')
  },

  computed: {
    ...mapState('gallery', ['image'])
  },

  methods: {
    async loadGalleryImage() {
      await this.$store.dispatch('gallery/loadGalleryImage', this.imageId)
      this.loading = false
    },

    ...mapMutations('gallery', [
      'setCaption'
    ]),

    save() {
      this.working = true
      this.$store.dispatch('gallery/updateGalleryImage').then(() => {
        this.$toast.success('Changes saved.')
        this.working = false
        this.$close(true)
      }).catch(() => {
      }).then(() => {
        this.working = false
      })
    }

  }

}
</script>